<template>
  <div class="about-us">
    <div class="banner">
      <img src="http://ylxh-service.oss-cn-hangzhou.aliyuncs.com/banner-about-us.jpg" alt="">
    </div>
    <div class="block-wrap">
      <div class="intro">
        <div class="intro-title">
          <img src="../../assets/images/about-us-title.png" alt="">
        </div>
        <div class="intro-box">
          <div class="intro-bg"></div>
          <div class="intro-detail">
            <h3>浙江省风景园林学会</h3>
            <div class="block-detail-icon"><i></i><i></i><i></i></div>
            <div class="intro-detail-text">
              浙江省风景园林学会(Zhejiang Society of Landscape Architecture，缩写为ZSLA)成立于1983年5月19日，是经浙江省民政厅核准登记的非盈利性社会组织，业务主管单位是浙江省住房和城乡建设厅。
            </div>
            <div class="intro-detail-text">
              学会现为第七届理事会，由201名理事组成。目前拥有团体会员613家单位、个人会员1500多人，涵盖全省风景园林行业各级管理部门、科研院校以及规划设计、施工建设、管理养护等企事业单位和大批行业精英人士。
            </div>
            <div class="intro-detail-text">
              学会通过举办各类活动为会员提供广阔的交流平台和合作空间，通过科普宣传引导全社会提高人居环境审美辨识度,促进行业健康发展,努力实现以下目标:推进浙江大地园林化,实现人与自然和谐共生;践行公园城市理念,构筑诗意人居环境。
            </div>       
            <div class="intro-detail-text">
              为提升全省园林绿化事业全产业链的可持续发展，学会常年举办各项丰富多彩的专业活动。如开展职业技能竞赛，协助技能评审鉴定和继续教育;举办浙江省风景园林学会优秀园林工程奖、浙江省园林绿化工程施工安全生产标准化管理优良工地的评选活动，并择优推荐参评“钱江杯（建设工程)”;召开园林人居论坛、青年设计师论坛、科技工作者座谈会等学术交流及咨询活动等;举行园林绿化养护和建设培训、园林大讲堂等专业培训;组织行业标准制定、课题研究等;编辑、发行《浙江园林》季刊;组织观摩和学习全省优秀园林景观工程等。
            </div>
            <div class="intro-detail-text">
              学会是浙江省民政厅评定的“5A级社会组织”，多次被中国风景园林学会评为“先进集体”,连续八年被省科协授予“学会工作绩效评价优秀单位”等称号。学会始终坚持以人为本和地域特色，践行服务社会、服务行业、服务会员的初心使命，携手广大会员努力打造“浙派园林”风貌，改善城乡生态和人居环境，助力美丽浙江和大花园建设，为高质量发展建设共同富裕示范区添砖加瓦。
            </div>
            <!-- <div class="card-more">查看详情-></div> -->

          </div>
        </div>
      </div>
    </div>
    <div class="block-wrap incorporation">
      <div>
        <div class="block-title">
          <h3>学会章程</h3>
          <span>Articles of Incorporation</span>
        </div>
        <div class="incorporation-desc">第一条&nbsp;&nbsp;&nbsp;&nbsp;本会名称为浙江省风景园林学会,英文名为Zhejiang  Society  of Landscape Architecture,缩写名字为Z S L A。</div>
        <div class="incorporation-block">
          <div class="incorporation-block-detail">
            <p>第二条&nbsp;&nbsp;&nbsp;&nbsp;学会的性质：浙江省风景园林学会(以下简称本会)是浙江省境内从事风景园林绿化工程、盆景艺术、插花艺术、园林植物、园林动物、风景园林管理、风景园林设计及相关的科研院校等企业，事业单位和人士，自愿组成的全省性的学术组织，是经省民政厅注册登记，具有独立法人资格的自律性、非营利性社会团体。</p>
            <p>第三条&nbsp;&nbsp;&nbsp;&nbsp;本会宗旨：以习近平新时代生态文明思想为指引，组织和团结全省风景园林工作者，遵守宪法、法律和法规，践行社会主义核心价值观，遵守社会道德风尚，贯彻执行国家有关方针、政策，加强交流合作，改善行业管理，服务会员，维护会员合法权益，发挥行业基层单位和政府部门之间的桥梁纽带作用。改善城市生态环境，继承发扬我国风景园林优秀传统，吸收世界先进风景园林科学技术，促进对外学术交流，提高我省的风景园林艺术水平，促进园林事业的可持续发展。</p>
            <div class="card-more" @click="toDetail('')">查看详情-></div>
          </div>
          <div class="incorporation-block-img">
            <img src="http://ylxh-service.oss-cn-hangzhou.aliyuncs.com/about-us-incorporation.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <!-- <Devlop :list="greatEventList" />-->
		<Organization :list="orgList" />
		<Boss :list="councilList" />
    <!-- <div class="block-wrap">
      <div class="team">
        <div class="block-title">
          <h3>团队展示</h3>
          <span>Team Presentation</span>
        </div>
        <div class="team-content">
          <div class="team-content-item">
            <img src="../../assets/tempImages/renwu1@2x.png" alt="">
            <div class="team-content-item-detail">
              <h4>王健林</h4>
              <p>中华慈善总会荣誉会长<br>万达集团创办人兼董事长<br>中国经济十年商业领袖</p>
            </div>
          </div>
          <div class="team-content-item">
            <img src="../../assets/tempImages/renwu2@2x.png" alt="">
            <div class="team-content-item-detail">
              <h4>王健林</h4>
              <p>中华慈善总会荣誉会长<br>万达集团创办人兼董事长<br>中国经济十年商业领袖</p>
            </div>
          </div>
          <div class="team-content-item">
            <img src="../../assets/tempImages/renwu3@2x.png" alt="">
            <div class="team-content-item-detail">
              <h4>王健林</h4>
              <p>中华慈善总会荣誉会长<br>万达集团创办人兼董事长<br>中国经济十年商业领袖</p>
            </div>
          </div>
          <div class="team-content-item">
            <img src="../../assets/tempImages/renwu4@2x.png" alt="">
            <div class="team-content-item-detail">
              <h4>王健林</h4>
              <p>中华慈善总会荣誉会长<br>万达集团创办人兼董事长<br>中国经济十年商业领袖</p>
            </div>
          </div>
        </div>
      </div>
      <SplitLine />
    </div> -->
    <div class="block-wrap contact-wrap">
      <div>
        <div class="block-title">
          <h3>联系我们</h3>
          <span>Contact</span>
        </div>
        <div class="contact-box">
          <div class="left-box">
            <h4>浙江省风景园林学会</h4>
            <p>地址：杭州市西湖区保俶路238号南2楼</p>
            <p>电话：0571-89938001、87999751、88832250(传真)</p>
            <p>邮箱：zjsfjyl@163.com</p>
            <p>公众号：浙江园林</p>         
          </div>
          <div class="map-box">
            <Map :showMarker="true"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import Map from '@/components/Map.vue';
import router from '@/router';
import Organization from './Organization.vue';
import Boss from './Boss.vue';
import Devlop from './Devlop.vue';
import { getData } from './service/api';

export default {
  data() {
    return {
      greatEventList: [],
      orgList: [],
      councilList: [],
    }
  },
  components: {
    Map,
    Devlop,
		Organization,
		Boss
  },
  mounted() {
    this.init();        
  },
  methods: {
    init() {
      getData().then(res => {
        this.orgList = (res.institution || []).map(item => {
          const coverFile = item.fileList && item.fileList.length ? item.fileList.find(f => f.fileBizType === 'cover') : null;
          if (coverFile && coverFile.url) {
            item.coverImg = coverFile.url;
          }
          return item;
        });
        this.greatEventList = (res.greatEvent || []).map((item, idx) => {
          item._index = idx < 10 ? `0${idx+1}` : idx+1;
          item._releaseTime = item.releaseDate ? moment(item.releaseDate * 1000).format('YYYY-MM-DD') : '-';
          const coverFile = item.fileList && item.fileList.length ? item.fileList.find(f => f.fileBizType === 'cover') : null;
          if (coverFile && coverFile.url) {
            item.coverImg = coverFile.url;
          }
          return item;
        });
        this.councilList = (res.council || []).map(item => {
          const coverFile = item.fileList && item.fileList.length ? item.fileList.find(f => f.fileBizType === 'cover') : null;
          if (coverFile && coverFile.url) {
            item.coverImg = coverFile.url;
          }
          return item;
        });;

        if(this.$route.query.skipBottom && this.$route.query.skipBottom == '1'){
          window.scrollTo(0, document.body.scrollHeight);
        }
      });
    },
    toDetail() {
      router.push('/aboutus/client/detail?aId=incorporation');
    }
  }
}
</script>

<style lang="less" scoped>
.banner {
  width: 100%;

  > img {
    display: block;
    width: 100%;
  }
}
.block-title {
  display: flex;
  align-items: flex-end;

  h3 {
    font-size: 32px;
    font-family: PingFang SC;
    font-weight: 800;
    color: #131415;
    margin-right: 20px;
  }

  span {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #131415;
    opacity: 0.2;
  }
}
.card-more {
  &:hover {
    background: #06AE63;
    color: #FFFFFF;
  }
}
.intro {
  padding-top: 64px;
  padding-bottom: 73px;

  &-title {
    width: 285px;
    margin: 0 auto 71px;

    > img {
      display: block;
      width: 100%;
    }
  }

  &-box {
    display: flex;
    justify-content: space-between;

    .intro-bg {
      width: 535px;
      height: 581px;
      background: url('http://ylxh-service.oss-cn-hangzhou.aliyuncs.com/about-us-bg.jpg') no-repeat center center;
	    background-size: 100% 100%;
    }

    .intro-detail {
      h4 {
        font-size: 26px;
        font-family: PingFang SC;
        font-weight: 800;
        color: #131415;
        margin-bottom: 21px;
      }

      .block-detail-icon {
        margin-bottom: 36px;
      }

      .intro-detail-text {
        width: 553px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #787878;
        line-height: 28px;
        margin-bottom: 15px;
        text-indent:2em;
      }
    }
  }
}
.incorporation {
  width: 100%;
  height: 586px;
  background: url(../../assets/images/about-incorporation-bg.png) no-repeat center center;
  background-size: 100% 100%;

  > div {
    padding-top: 76px;
  }

  .block-title {
    margin-bottom: 37px;
  }

  &-desc {
    font-size: 16px;
	line-height: 28px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #131415;
    margin-bottom: 30px;
  }

  &-block {
    display: flex;
    justify-content: space-between;

    &-detail {
      flex: 1;
      margin-right: 52px;

      p {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #787878;
        line-height: 28px;
        margin-bottom: 15px;
      }
    }

    &-img {
      width: 420px;

      > img {
        display: block;
        width: 100%;
      }
    }
  }
}
.team {
  .block-title {
    margin-bottom: 50px;
  }

  &-content {
    overflow: hidden;
    display: flex;

    &-item {
      width: 286px;
      height: 400px;
      margin-right: 19px;
      position: relative;
      cursor: pointer;

      &:last-child {
        margin-right: 0;
      }

      &:hover {
        .team-content-item-detail {
          z-index: 1;
        }
      }

      img {
        display: block;
        width: 100%;
        height: 100%;
      }

      &-detail {
        z-index: -1;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        padding-bottom: 27px;
        background: rgba(6,174,99,0.8000);
        box-shadow: 0px 3px 10px 0px rgba(0,0,0,0.2000);
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        padding-left: 30px;

        h4 {
          font-size: 26px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #FFFFFF;
          margin-bottom: 25px;
        }
        
        p {
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 30px;
        }
      }
    }
  }
}
.contact-wrap {
  padding-bottom: 97px;
  
  .block-title {
    margin-bottom: 93px;
  }

  .contact-box {
    position: relative;
    .left-box {
      width: 546px;
      height: 481px;
      background: url(../../assets/images/train-bg.png) no-repeat center center;
      background-size: 100% 100%;
      padding-left: 31px;
      padding-top: 110px;

      h4 {
        position: relative;
        height: 25px;
        font-size: 26px;
        font-family: PingFang SC;
        font-weight: 800;
        color: #FFFFFF;
        margin-bottom: 72px;

        &::after {
          content: '';
          width: 54px;
          height: 4px;
          background: #FFFFFF;
          position: absolute;
          left: 0;
          bottom: -29px;
        }
      }

      p {
        height: 16px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 24px;
        margin-bottom: 20px;
      }
    }

    .map-box {
      width: 767px;
      height: 440px;
      position: absolute;
      right: 0;
      top: 21px;
      padding: 10px;
      background: #FFFFFF;

      .map {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>